export default "__VITE_ASSET__DE8sRGZo__"